import { AppConfig } from '../models/app-config.model';

export class AppConfigProvider {
  constructor(public appConfig: AppConfig) {}
}
